import { useLocation } from 'react-router-dom'

function useActiveRoute() {
    const location = useLocation()
    const path = location.pathname

    return path
}

export default useActiveRoute